
import { defineComponent, ref } from "vue";
import { usePlugin } from "@/plugins";
import { LoginResponse, LoginRequest } from "@/types";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers, minLength } from "@vuelidate/validators";
export default defineComponent({
  name: "Login",
  setup() {
    const {
      error,
      axios,
      useState,
      router,
      setIdentity,
      route,
      setLoading,
      getUserProfile,
    } = usePlugin();

    const login = ref({
      username: "",
      password: "",
    });

    const rules = {
      username: {
        required: helpers.withMessage("กรุณาระบุ Username", required),
        minLength: helpers.withMessage(
          "กรุณาระบุ ความยาว 4 ตัวอักษรอย่างน้อย",
          minLength(4)
        ),
      },
      password: {
        required: helpers.withMessage("กรุณาระบุ Password", required),
      },
    };
    const v$ = useVuelidate(rules, login, { $autoDirty: true });
    const state = useState();

    const onLogin = async (e: any) => {
      v$.value.$reset();
      v$.value.$touch();
      if (v$.value.$invalid) return;

      setLoading(true);
      try {
        const response = await axios.post<LoginResponse>("api/v1/login", {
          username: login.value.username,
          password: login.value.password,
          system: "hrdsmart",
        } as LoginRequest);

        if (response.data.message != "") {
          error(response.data.message);
        } else {
          // store.commit("login", {
          //   token: response.data.token,
          //   username: response.data.employeeId,
          // });
          state.value.authentication.token = response.data.token;
          state.value.authentication.username = response.data.employeeId;
          setIdentity();
          await getUserProfile();

          const name = route.query["name"] as string;
          const params = JSON.parse((route.query["params"] as string) ?? "{}");
          if (name) {
            router.replace({ name: name, params: params });
          } else {
            await router.replace({ name: "menu" });
          }
        }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onPopupWac = () => {
      window.open("https://minutemaid.haadthip.com/ad_check/", "_blank");
    };

    return {
      onLogin,
      onPopupWac,

      login,

      v$,
    };
  },
});
